
import React from 'react';
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { UploadStats } from './types';

interface ProgressDisplayProps {
  progress: number;
  stats: UploadStats;
}

export const ProgressDisplay = ({ progress, stats }: ProgressDisplayProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Progress value={progress} className="w-full" />
        <p className="text-sm text-gray-500 text-center">{progress}% Complete</p>
      </div>
      
      <div className="flex flex-wrap gap-2 justify-center">
        <Badge variant="outline" className="flex gap-1">
          <span className="font-bold">Total:</span> {stats.total}
        </Badge>
        <Badge variant="secondary" className="flex gap-1">
          <span className="font-bold">Processed:</span> {stats.processed}
        </Badge>
        <Badge variant="default" className="flex gap-1">
          <span className="font-bold">Created:</span> {stats.created}
        </Badge>
        <Badge variant="outline" className="bg-blue-50 text-blue-700 flex gap-1">
          <span className="font-bold">Updated:</span> {stats.updated}
        </Badge>
        <Badge variant="outline" className="bg-amber-50 text-amber-700 flex gap-1">
          <span className="font-bold">Warnings:</span> {stats.warnings}
        </Badge>
        {stats.errors > 0 && (
          <Badge variant="destructive" className="flex gap-1">
            <span className="font-bold">Errors:</span> {stats.errors}
          </Badge>
        )}
      </div>
      
      {stats.total > 30 && (
        <p className="text-sm text-center text-amber-600">
          Processing large batch. Individual notifications are suppressed.
        </p>
      )}
    </div>
  );
};
